const config = {
  test: {
    sdk: 'https://o.alicdn.com/QTSDK/quicktracking-sdk/qt_web.umd.js',
    appKey: 'e67nzgjc693z3eyluslbxaj8',
    aplus_host: 'quickaplus-test-api.gwm.cn',
    platformName: '聚合APP',
  },
  prod: {
    sdk: 'https://o.alicdn.com/QTSDK/quicktracking-sdk/qt_web.umd.js',
    appKey: '2sovxvm9h5uvtzc7nadglbfc',
    aplus_host: 'quickaplus-api.gwm.cn',
    platformName: '聚合APP',
  },
}

export default config
